/**
 * Contacts — the people at customer and supplier accounts.
 *
 * A contact belongs to a party (a customer or a supplier) rather than
 * standing alone, which is why the account column matters: a contact with no
 * party is unreachable from the record it belongs to.
 */
import { ResourceListPage } from "@/components/ResourceListPage";
import { Badge } from "@/components/ui";
import { personName, type ContactRow } from "./types";

export function CrmContactsPage() {
  return (
    <ResourceListPage<ContactRow>
      title="Contacts"
      subtitle="People at customer and supplier accounts, with one primary contact per account."
      breadcrumb={["CRM", "Contacts"]}
      path="/contacts"
      queryKey={["crm", "contacts"]}
      emptyTitle="No contacts"
      emptyMessage="Contacts are added from a customer or supplier record, so the account they belong to is never ambiguous."
      columns={[
        {
          key: "name",
          label: "Name",
          render: (r) => personName(r.first_name, r.last_name),
        },
        { key: "email", label: "Email", render: (r) => r.email ?? "—" },
        { key: "phone", label: "Phone", render: (r) => r.phone ?? "—" },
        { key: "party_type", label: "Account type" },
        {
          key: "is_primary",
          label: "Primary",
          render: (r) =>
            r.is_primary ? <Badge tone="primary">Primary</Badge> : "—",
        },
      ]}
    />
  );
}
